import CompraSearchHeader from './CompraSearchHeader';

export default CompraSearchHeader;
